<template>
  <div class="col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="true"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-estado",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  data() {
    return {
      estado: ""
    };
  },
  computed: {
    endereco() {
      return this.$store.state.endereco;
    }
  },
  asyncComputed: {
    valueComputed() {
      let value;

      if (this.endereco.cep) value = this.endereco.uf;
      else value = this.value;

      this.estado = value;

      return value;
    }
  },
  watch: {
    estado(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Estado.vue